/*jslint browser: true */

'use strict';

var React = require('react'),
    App = require('./app');

React.render(<App />, document.body);



/** WEBPACK FOOTER **
 ** ./example/src/index.jsx
 **/